import { useCallback, useRef } from "react";
export function useLongPress(onLongPress, delay = 500) {
    const timerRef = useRef(null);
    const movedRef = useRef(false);
    const start = useCallback((e) => {
        movedRef.current = false;
        timerRef.current = setTimeout(() => {
            if (!movedRef.current)
                onLongPress(e);
        }, delay);
    }, [onLongPress, delay]);
    const cancel = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    const move = useCallback(() => {
        movedRef.current = true;
        cancel();
    }, [cancel]);
    return {
        onTouchStart: start,
        onTouchEnd: cancel,
        onTouchMove: move,
        onMouseDown: start,
        onMouseUp: cancel,
        onMouseMove: move,
    };
}
